import { ProductionComponentInstanceStatus } from '@paragon/contract-library';
import { designService } from '@paragon/data-connections';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { getProductionComponentInstancesByBundleGuid } from '../selectors/getProductionComponentInstancesByBundleGuid';
import { statusSet } from '../store/productionComponentInstancesSlice';
import { AsyncThunkActionVoid } from './thunkActions';

export function setStatus(
  bundleGuids: readonly string[],
  status: ProductionComponentInstanceStatus,
  spinner = true,
): AsyncThunkActionVoid {
  return async function setStatusThunkAction(dispatch, getState) {
    const spinnerId = spinner ? dispatch(addSpinnerMessage('Updating status...')) : null;

    try {
      const productionComponentInstancesByBundleGuid = getProductionComponentInstancesByBundleGuid(getState());
      const productionComponentInstanceGuidsForBundleGuids = bundleGuids
        .flatMap((bundleGuid) => productionComponentInstancesByBundleGuid[bundleGuid])
        .map((productionComponentInstance) => productionComponentInstance.guid);
      await designService.productionComponentInstances.setStatus(
        productionComponentInstanceGuidsForBundleGuids,
        status,
      );
      dispatch(statusSet({ productionComponentInstanceGuids: productionComponentInstanceGuidsForBundleGuids, status }));
    } catch {
      dispatch(enqueueError('Error updating status'));
    } finally {
      if (spinnerId != null) dispatch(removeSpinnerMessage(spinnerId));
    }
  };
}
